/**
 *
 * Styles for AdditionalInformation
 *
 */

import styled from "styled-components";
import { Headline } from "root/libs/ui-components/src";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const AdditionalInformationWrapper = styled.div`
  margin-bottom: var(--dui-size-space-20x);

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: var(--gaq-size-space-30px);
  }
`;

export const AdditionalInformationHeadline = styled(Headline)`
  margin-bottom: var(--dui-size-space-6x);
`;

export const AdditionalInformationList = styled.ul`
  list-style-type: none;
`;

export const StyledNoticeText = styled.div`
  margin-top: 20px !important;
`;
